// SET_OBJECT,
//   ADD_OBJECT,
//   UPDATE_OBJECT,
//   DELETE_OBJECT,

import { createAction } from '@reduxjs/toolkit';

import types from '../actionTypes';

const setAllObjects = createAction(types.SET_OBJECT);

const setObject = createAction(types.ADD_OBJECT);

const setUpdatedObject = createAction(types.UPDATE_OBJECT);

const setDeleteObject = createAction(types.DELETE_OBJECT);

export { setAllObjects, setObject, setUpdatedObject, setDeleteObject };
